
import { BaseVue } from "@newview/base-web";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import JSONEditor from "jsoneditor";
@Component({
  name: "JsonEdit"
})
export default class JsonEdit extends BaseVue {
  @Prop({ default: () => ('') })
  JsonData: any; //搜索条件配置参数

  @Watch("JsonData", { deep: true })
  public onTokenChange(val: any, oldVal: any) {
    // if (this.JsonData == val) return;
     if (this.editor) this.editor.set(val);
  }

  jsonEditBoxId = "jsoneditor_" + this.NewGuid();
  editor;
  mounted() {
    const container = document.getElementById(this.jsonEditBoxId);
    const options = {
      // modes: ['tree','code'],     //可以设置多种模式随意切换
      mode: "code", // tree，view，form，code，text
      onChange: this.jsonDataChange
    };

    this.editor = new JSONEditor(container, options);

    this.editor.set(this.JsonData);
  }
  //设置json数据
  setJsonData(JsonData) {
      this.editor.set(JsonData); 
  }
  //获取配置好的json数据
  getJsonData() {
    let jsonData = this.editor.get();
    return jsonData;
  }
  jsonDataChange() {
    let jsd = this.editor.get();
    this.$emit("jsonDataChange", jsd);
  }
}
